import React from "react";
import PropTypes from "prop-types";
import { CustomContainer } from "../DependencyHelper";
import LabelText from "../label/LabelText";
import Image from "../image/image";

import styles from "./InfoClickCollect.module.scss";

const InfoClickCollect = ({ className, type, text, imageSrc, imageWidth, imageHeight }) => {
  return (
    <CustomContainer className={`${styles["info-click-collect"]} ${styles[type]} ${className}`}>
      {imageSrc &&
      <Image
        className={styles["info-click-collect--img"]}
        img_path={imageSrc}
        img_width={imageWidth}
        img_height={imageHeight}
        img_alt={type || "icon"}
      />
      }
      <LabelText className={styles["info-click-collect--label"]}>
        {text}
      </LabelText>
    </CustomContainer>
  );
};

InfoClickCollect.defaultProps = {
  className: "info-click-collect",
  type: "info",
  text: "",
  imageSrc: "",
  imageWidth: "1.3125rem",
  imageHeight: "1.3125rem"
};

InfoClickCollect.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  imageSrc: PropTypes.string,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
};

export default InfoClickCollect;
